module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.window),
      callback: function($$v) {
        _vm.window = $$v
      },
      expression: "window"
    }
  }, [_c('v-window-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": "",
      "dark": ""
    }
  }, [(_vm.invoice) ? _c('invoice-list-item', {
    attrs: {
      "invoice": _vm.invoice
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', [_c('v-subheader', {
    staticClass: "pa-0 overline"
  }, [_vm._v("Send to client\n          "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showCustomMessage = !_vm.showCustomMessage
      }
    }
  }, [_vm._v("Add custom message")])], 1), _vm._v(" "), (_vm.showCustomMessage) ? _c('v-textarea', {
    staticClass: "caption",
    attrs: {
      "outline": "",
      "rows": "2",
      "label": "Custom message",
      "hint": "Include a custom message in your email"
    },
    model: {
      value: (_vm.customMessage),
      callback: function($$v) {
        _vm.customMessage = $$v
      },
      expression: "customMessage"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.whatsapplink) ? _c('v-btn', {
    staticStyle: {
      "float": "right",
      "margin-top": "2px"
    },
    attrs: {
      "outline": "",
      "href": _vm.whatsapplink,
      "target": "_blank",
      "color": "green",
      "dark": "",
      "small": ""
    }
  }, [_vm._v("\n          Send via WhatsApp\n          "), _c('v-icon', {
    staticClass: "ml-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1) : _vm._e(), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ma-0",
    attrs: {
      "label": "Send as SMS",
      "disabled": !_vm.hasPhoneNumber,
      "hint": _vm.sendAsSMSHint,
      "persistent-hint": "",
      "light": ""
    },
    model: {
      value: (_vm.sendAsSMS),
      callback: function($$v) {
        _vm.sendAsSMS = $$v
      },
      expression: "sendAsSMS"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ma-0 mt-2",
    attrs: {
      "label": "Send to email",
      "hint": _vm.sendToCustomerHint,
      "disabled": _vm.hasValidEmail === false,
      "persistent-hint": "",
      "light": ""
    },
    model: {
      value: (_vm.sendToCustomer),
      callback: function($$v) {
        _vm.sendToCustomer = $$v
      },
      expression: "sendToCustomer"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', {
    staticClass: "pa-0 ma-0 overline"
  }, [_vm._v("Send to me")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ma-0",
    attrs: {
      "label": "Send to me",
      "hint": _vm.sendToMeHint,
      "persistent-hint": "",
      "light": ""
    },
    model: {
      value: (_vm.sendToMe),
      callback: function($$v) {
        _vm.sendToMe = $$v
      },
      expression: "sendToMe"
    }
  }), _vm._v(" "), _c('vuex-loader', {
    attrs: {
      "request-id": _vm.sendSMSReqId
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-2",
    attrs: {
      "clearable": "",
      "type": "email",
      "label": "Send to email",
      "hint": "Type the email address you would like to send this invoice to",
      "rules": [_vm.rules.email]
    },
    model: {
      value: (_vm.freeFormEmail),
      callback: function($$v) {
        _vm.freeFormEmail = $$v
      },
      expression: "freeFormEmail"
    }
  }), _vm._v(" "), (_vm.recipientsExist) ? _c('div', {
    staticClass: "mt-2",
    attrs: {
      "transition": "slide-y-transition"
    }
  }, [_c('v-subheader', {
    staticClass: "pa-0"
  }, [_vm._v("Sending to")]), _vm._v(" "), _vm._l((_vm.emailList), function(email) {
    return _c('v-chip', {
      key: email,
      attrs: {
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "color": "teal white--text"
      }
    }, [_c('v-icon', {
      attrs: {
        "small": "",
        "dark": ""
      }
    }, [_vm._v("email")])], 1), _vm._v("\n            " + _vm._s(email) + "\n          ")], 1)
  }), _vm._v(" "), (_vm.sendAsSMS) ? _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_c('v-avatar', {
    attrs: {
      "color": "teal white--text"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("chat")])], 1), _vm._v("\n            " + _vm._s(_vm.normalizedClient.phone_number) + "\n          ")], 1) : _vm._e()], 2) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [(_vm.withClose) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.relationshipId) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "loading": _vm.requests.contact.loading
    },
    on: {
      "click": _vm.refreshContact
    }
  }, [_vm._v("Reload contact info")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "color": "primary",
      "disabled": !_vm.recipientsExist
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("Send  \n            "), _c('v-icon', [_vm._v("send")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "text-xs-center"
  }, [(_vm.loading) ? [_c('v-progress-circular', {
    attrs: {
      "width": "2",
      "color": "amber",
      "size": "36",
      "indeterminate": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v("Sending")])] : _vm._e(), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": "warning",
      "value": _vm.failedMessages && _vm.failedMessages.length > 0
    }
  }, [_vm._v("\n          Some messages failed to send\n        ")]), _vm._v(" "), (_vm.messageIdsToWatch && _vm.messageIdsToWatch.length > 0) ? _c('v-list', {
    attrs: {
      "dense": "",
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v("Sent messages")]), _vm._v(" "), _vm._l((_vm.messageIdsToWatch), function(messageId) {
    return _c('communication-watcher', {
      key: messageId,
      attrs: {
        "message-id": messageId
      }
    })
  })], 2) : _vm._e()], 2), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.$emit("close");
        _vm.window = 0;
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c6d5334","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/SendInvoice.vue
// module id = 1459
// module chunks = 9